import React, { useState, useEffect, useRef, useCallback } from 'react';
import axios from 'axios';
import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import CommonBooking from '../Common/common_booking';
import { Link } from 'react-router-dom';
import { generatePath } from 'react-router';

const BookingList = (props) => {
  const [bookData, setBookData] = useState(null);
  const [lockData, setLockData] = useState(false);

  const { addToast } = useToasts();
  const componentRef = useRef();
  const refreshBook = useCallback(async () => {
    //トークンを取得
    const jwt = localStorage.getItem('jwt');

    var reg_params = {};
    reg_params = {
      "operator": "and",
      "where": [
        { "site_id": props.siteId },
        { "book_date": new Date(props.condition.searchData.book_date) }
      ]
    }
    // カテゴリ
    if (props.condition.searchData.category) {
      reg_params.where.push({ "category_id": props.condition.searchData.category });
    }
    if (props.condition.searchData.shop_id) {
      reg_params.where.push({ "shop_id": props.condition.searchData.shop_id });
    }
    const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/search/`, reg_params, { headers: { Authorization: `Bearer ${jwt}` } })).data;
    setBookData(data.filter(item => (props.condition.searchData.status === '' || props.condition.searchData.status.includes(item.booking_status))));
  }, [props.siteId, props.condition.searchData]);

  const handleStatusButtonClick = async (book_id, status, line_id) => {
    var sendtext = '';//この値を入れる
    var book = bookData.find(o => (o.book_id === book_id));
    console.log(book);
    console.log(status);
    if (book.booking_status === status) {
      // 同じボタンを押したときはひとつ前のステータスに戻す
      status = constClass.STATUS.REG;
    }
    if (status === constClass.STATUS.FIN && book.t_booking.status === constClass.STATUS.TREG && !window.confirm(`受付番号[${book.t_booking.receipt_num}]を予約承認済にします。よろしいですか？`)) {
      return;
    }
    if (status === constClass.STATUS.CCL && !window.confirm(`受付番号[${book.t_booking.receipt_num}]をキャンセルします。よろしいですか？`)) {
      return;
    }
    if (status === constClass.STATUS.FIN && !(book.t_booking.status === constClass.STATUS.TREG) && !window.confirm(`受付番号[${book.t_booking.receipt_num}]を来店済にします。よろしいですか？`)) {
      return;
    }
    if (status === constClass.STATUS.REG && !window.confirm(`受付番号[${book.t_booking.receipt_num}]のステータスを予約承認済に戻します。よろしいですか？`)) {
      return;
    }
    //仮予約の場合は予約承認済に変更
    if (status === constClass.STATUS.FIN && book.t_booking.status === constClass.STATUS.TREG) {
      status = constClass.STATUS.REG;
    }
    const jwt = localStorage.getItem('jwt');
    const params = {
      site_id: props.match.params.siteId,
      status,
      upd_name: props.user.userId
    };
    try {
      setLockData(true);
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/booking/backyard_status/${book_id}`, params, { headers: { Authorization: `Bearer ${jwt}` } });
      if (status === constClass.STATUS.REG && book.t_booking.status === constClass.STATUS.TREG) {
        sendtext = "受付番号：" + book.t_booking.receipt_num + "\nご予約が正式に確定しました";
      }
      if (status === constClass.STATUS.CCL) {
        sendtext = "受付番号：" + book.t_booking.receipt_num + "\n予約がキャンセルされました";
      }
      if (status === constClass.STATUS.FIN && !(book.t_booking.status === constClass.STATUS.TREG)) {
        sendtext = "受付番号：" + book.t_booking.receipt_num + "\n予約が来店済になりました";
      }
      if (status === constClass.STATUS.REG && book.t_booking.status !== constClass.STATUS.TREG) {
        sendtext = "受付番号：" + book.t_booking.receipt_num + "\nステータスを予約に戻します";
      }
      const send_params = {
        site_id: props.match.params.siteId,
        user_id: props.user.userId,
        text: sendtext,
        book_id: book_id,
        shop_id: props.user.shopId,
        old_status: book.booking_status,
      }
      //メッセージを送信
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/log/send`, send_params, { headers: { Authorization: `Bearer ${jwt}` } });

    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      addToast('ステータスを更新しました。', { appearance: 'success', autoDismiss: true });
      await refreshBook();
      setLockData(false);
    }
  }

  const renderButton = (data, status, statusName, additionalStatus = []) => {
    additionalStatus.push(status);
    return (
      <button type="button"
        disabled={lockData}
        className={`btn ${additionalStatus.includes(data.booking_status) ? 'btn-danger' : (constClass.ACTIVE_BUTTONS[data.booking_status].includes(status) || (data.booking_status === "TREG" && status === "FIN") ? 'btn-active' : 'btn-secondary')} mx-1`}
        onClick={() => handleStatusButtonClick(data.book_id, status, data.t_booking.detail_t_booking_customer.line_id)}>
        {(data.booking_status === "TREG" && status === "FIN") ? "予約承認" : additionalStatus.includes(data.booking_status) ? statusName : constClass.STATUS_NAME_BTN[status]}
      </button>
    )
  }

  useEffect(() => {
    var intervalId;
    async function fetchData() {
      await refreshBook();
      intervalId = setInterval(() => {
        refreshBook();
      }, 60000);
    }
    fetchData();
    return () => {
      clearInterval(intervalId);
    };
  }, [refreshBook]);


  const renderList = () => {
    return (
      <div ref={componentRef} className="print-list">
        <div className="row mb-0 p-0 ">
          <div className="col pl-0 text-left align-self-end">
            {(props.condition.searchData.category !== '' && props.condition.categoryList.length > 0) && <div className="row"><div className="col-12"><h4>{props.condition.categoryList.find(s => s.category_id === Number(props.condition.searchData.category)).category_name}</h4></div></div>}
          </div>
        </div>
        <div className="row mb-3 p-0">
          <div className="col-12 p-0">
            <table className="table table-bbooked table-striped" height="1">
              <thead>
                <tr>
                  <th className="text-center align-middle text-nowrap like-button">
                    受付<br />番号
                  </th>
                  <th className="text-center align-middle like-button">
                    カテゴリ
                  </th>
                  <th className="text-center align-middle like-button">
                    開始<br />時刻
                  </th>
                  <th className="text-center align-middle like-button">
                    終了<br />時刻
                  </th>
                  <th className="text-center align-middle like-button">
                    数量
                  </th>
                  <th className="text-center align-middle like-button">
                    氏名
                  </th>
                  <th className="text-center align-middle like-button">
                    ステータス
                  </th>
                  <th className="text-center align-middle print-none">
                    処理
                  </th>
                  <th className="text-center align-middle print-none">
                    詳細確認
                  </th>
                </tr>
              </thead>
              <tbody>
                {bookData.length <= 0 && <tr><td className="text-center align-middle p-3" colSpan={10}>条件に一致する予約がありません</td></tr>}
                {bookData.map((data, idx) => (
                  <tr key={idx}>
                    {/* 予約番号 */}
                    <td className="text-center align-middle p-1">
                      {data.t_booking.receipt_num}
                    </td>
                    {/* カテゴリ */}
                    <td className="text-center align-middle p-1">
                      {data.category_name}
                    </td>
                    {/* 開始時刻 */}
                    <td className="text-center align-middle p-1">
                      {CommonBooking.strTotime(data.start_time)}<br />
                    </td>
                    {/* 終了時刻 */}
                    <td className="text-center align-middle p-1">
                      {CommonBooking.strTotime(data.end_time)}<br />
                    </td>
                    {/* 数量 */}
                    <td className="text-center align-middle p-1">
                      {data.count}
                    </td>
                    {/* 氏名 */}
                    <td className="text-center align-middle p-1">
                      {data.customer_name}
                    </td>
                    {/* ステータス */}
                    <td className="text-center align-middle p-1">
                      {constClass.STATUS_NAME_PKG[data.booking_status]}
                    </td>
                    {/* 処理 */}
                    <td className="text-center align-middle text-nowrap p-1 print-none">
                      {renderButton(data, constClass.STATUS.FIN, constClass.STATUS_NAME_PKG.FIN)}
                      {renderButton(data, constClass.STATUS.CCL, constClass.STATUS_NAME_PKG.CCL)}
                    </td>
                    <td className="text-center align-middle text-nowrap p-1 print-none">
                      <Link to={`${generatePath(`${props.match.path}`, { siteId: props.match.params.siteId })}Bookingdetail?bk=${data.book_id}`}>詳細確認</Link>
                    </td>
                  </tr>
                ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="row d-none"><div className="col-12">{util.inspect(bookData)}</div></div>
      <div className="row d-none"><div className="col-12">{util.inspect(props.user)}</div></div>
      {bookData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {bookData !== null && renderList()}
    </div>
  )
}

export default BookingList;